import type { Address } from "viem"
import type { Config } from "wagmi"

import type { Token } from "@/domains/core"
import type { ApproveTokenAllowanceParams, TransactionReturnType } from "@/domains/on-chain/types"
import { approveOwnerSpenderAllowance, createLock } from "@/domains/on-chain"

import type { ICreateLockActions } from "./interfaces"

/**
 * Adapter that implements ICreateLockActions using the actual on-chain functions.
 * This is the production implementation injected into the interaction.
 */
export class CreateLockActionsAdapter implements ICreateLockActions {
  async approveTokenAllowance(params: ApproveTokenAllowanceParams): Promise<TransactionReturnType> {
    return await approveOwnerSpenderAllowance(params)
  }

  async createLock(params: {
    account: Address
    chainId: number
    config: Config
    vestedToken: Token
    amount: bigint
    secondsToExpire: number
  }): Promise<TransactionReturnType> {
    return await createLock(params)
  }
}
